import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/axios";

export const fetchQuestions = createAsyncThunk(
  "question/fetchQuestions",
  async ({ page = 1, limit = 25, categoryId, subcategoryId, previousExamRefId, searchTerm, courseId, questionType, status } = {}) => {
    let url = 'question/getAllQuestion?'
    if (categoryId) {
      const categoryParam = Array.isArray(categoryId) ? categoryId.join(",") : categoryId;
      if (categoryParam) url += `&categoryId=${categoryParam}`;
    }
    if (subcategoryId) {
      const subCategoryParam = Array.isArray(subcategoryId) ? subcategoryId.join(",") : subcategoryId;
      if (subCategoryParam) url += `&subCategoryId=${subCategoryParam}`;
    }
    if (previousExamRefId) {
      const examRefParam = Array.isArray(previousExamRefId) ? previousExamRefId.join(",") : previousExamRefId;
      if (examRefParam) url += `&previousExamRefId=${examRefParam}`;
    }
    if (courseId) {
      const courseParam = Array.isArray(courseId) ? courseId.join(",") : courseId;
      if (courseParam) url += `&courseId=${courseParam}`;
    }
    if (searchTerm) url += `&searchTerm=${searchTerm}`;
    if (questionType && questionType !== "All") url += `&questionType=${questionType}`;
    if (status && status !== "all") url += `&status=${status}`;
    const response = await apiService.get(url + '&page=' + page + '&limit=' + limit);
    return response;
  }
);
export const toggleSwitch = createAsyncThunk(
  "question/toggleSwitch",
  async (data) => {
    const response = await apiService.put("/question/updateStatus", {
      questionId: data?._id,
      isActive: data?.isActive,
    });
    return data;
  }
);

export const addQuestion = createAsyncThunk(
  "question/addQuestion",
  async (questionData, { rejectWithValue }) => {
    try {
      const response = await apiService.post("/question/add", questionData);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateQuestion = createAsyncThunk(
  "question/updateQuestion",
  async ({ questionId, updateData }) => {
    const response = await apiService.put("/question/update", {
      questionId,
      ...updateData,
    });
    return response.data;
  }
);

export const deleteQuestion = createAsyncThunk(
  "question/deleteQuestion",
  async (questionId) => {
    await apiService.put("/question/delete", {
      questionId,
      isDelete: true,
    });
    return questionId;
  }
);

const questionSlice = createSlice({
  name: "question",
  initialState: {
    questions: [],
    totalQuestions: 0,
    loading: false,
    error: null,
  },
  reducers: {
    clearQuestions: (state) => {
      state.questions = [];
      state.totalQuestions = 0;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuestions.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchQuestions.fulfilled, (state, action) => {
        state.loading = false;
        state.questions = action.payload?.questions || [];
        state.totalQuestions = action.payload?.pagination?.total || 0;
      })
      .addCase(fetchQuestions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addQuestion.fulfilled, (state, action) => {
        state.questions.push(action.payload.data);
      })
      .addCase(updateQuestion.fulfilled, (state, action) => {
        const index = state.questions?.findIndex(
          (cat) => cat?._id === action?.payload?._id
        );
        if (index !== -1) {
          state.questions[index] = action.payload;
        }
      })
      .addCase(toggleSwitch.fulfilled, (state, action) => {
        const index = state.questions.findIndex(
          (q) => q._id === action.payload._id
        );
        if (index !== -1) {
          state.questions[index].isActive = action.payload.isActive;
        }
      })
      .addCase(deleteQuestion.fulfilled, (state, action) => {
        state.questions = state.questions.filter(
          (cat) => cat._id !== action.payload
        );
      });
  },
});

export const { clearQuestions } = questionSlice.actions;
export default questionSlice.reducer;
